import { Navigate, useLocation } from 'react-router-dom'
import { useIsPc } from '@/shared/composables/useIsPc'
import { OrgNewMobile } from '@/public/features/org/ui/OrgNewMobile'
import { OrgNewPcOrg } from '@/public/features/org/ui/orgNewPc/OrgNewPcOrg'
import { OrgNewPcManager } from '@/public/features/org/ui/orgNewPc/OrgNewPcManager'
import { OrgNewPcCardContent } from '@/public/features/org/ui/orgNewPc/OrgNewPcCardContent'
import { OrgNewPcCard } from '@/public/features/org/ui/orgNewPc/OrgNewPcCard'
import { OrgNewPcCardDone } from '@/public/features/org/ui/orgNewPc/OrgNewPcCardDone'
import {
  ORG_LAST_STEP,
  PC_CARD_FIRST_STEP,
  PC_ORG_LAST_STEP,
  TOTAL_STEPS,
} from '@/public/features/org/constants/orgNew'
import { useOrgNewDraft } from '@/public/features/org/composables/orgNewDraft'

export function OrgNewFlowPage() {
  const { pathname } = useLocation()
  const isPc = useIsPc()
  const step = readStep(pathname)
  const draft = useOrgNewDraft(step ?? 1)

  if (step === null) return <Navigate to="/orgs/new" replace />

  if (draft.stage === 'form' && step > draft.firstIncompleteStep) {
    const to = draft.firstIncompleteStep === 1 ? '/orgs/new' : `/orgs/new/${draft.firstIncompleteStep}`
    return <Navigate to={to} replace />
  }

  // PC 는 모바일 10단계를 시안대로 네 페이지로 묶는다 — 1~3 / 4 / 5 / 6~10.
  // 완료 화면(`card-done`)까지 PC 시안이 있다.
  if (isPc && draft.stage === 'form' && step <= PC_ORG_LAST_STEP) return <OrgNewPcOrg draft={draft} />
  if (isPc && draft.stage === 'form' && step === ORG_LAST_STEP) return <OrgNewPcManager draft={draft} />
  if (isPc && draft.stage === 'form' && step === PC_CARD_FIRST_STEP)
    return <OrgNewPcCardContent draft={draft} />
  if (isPc && draft.stage === 'form' && step > PC_CARD_FIRST_STEP) return <OrgNewPcCard draft={draft} />
  if (isPc && draft.stage === 'card-done') return <OrgNewPcCardDone draft={draft} />

  return <OrgNewMobile draft={draft} />
}

function readStep(pathname: string): number | null {
  const tail = pathname.replace(/^\/orgs\/new\/?/, '')
  if (tail === '') return 1
  const n = Number(tail)
  if (!Number.isInteger(n) || n < 2 || n > TOTAL_STEPS) return null
  return n
}
